import * as OpenCC from 'opencc-js';
import { getSurnamePinyin } from './surname';

const convertName = OpenCC.Converter({ from: 'hk', to: 'cn' });

/** 人工填写只整理大小写和空格，不重新生成，保留牌照登记拼写。 */
export function normalizeSignNamePinyin(value) {
  return String(value || '').trim().replace(/\s+/g, ' ').toUpperCase();
}

/** 复用预约姓名的繁转简、复姓优先和姓/名一个空格规则。 */
export function createSignNamePinyin(name) {
  return normalizeSignNamePinyin(getSurnamePinyin(convertName(String(name || '').trim())).join(' '));
}

/** 按需校验必填并保留30字符上限，不限制姓名字符种类。 */
export function isValidSignNamePinyin(value, required = true) {
  const name = normalizeSignNamePinyin(value);
  return (!required || name.length > 0) && name.length <= 30;
}

/** 两个员工/账号表单共用，不覆盖已有或人工填写的签单拼音。 */
export const signNamePinyinFormMixin = {
  data() { return { signNamePinyinAutoValue: '' }; },
  computed: {
    signNamePinyinRule() {
      return {
        required: true, trigger: 'blur',
        validator: (rule, value, callback) => callback(isValidSignNamePinyin(value) ? undefined
          : new Error('英文拼音（签单用）必填，最多30个字符'))
      };
    }
  },
  watch: {
    'formData.name'() {
      const current = normalizeSignNamePinyin(this.formData.signNamePinyin);
      if (!current || current === this.signNamePinyinAutoValue) this.generateSigningPinyin();
    }
  },
  methods: {
    /** 只让自动生成值跟随中文姓名变化；人工值保持不动。 */
    generateSigningPinyin() {
      const generated = createSignNamePinyin(this.formData.name);
      this.signNamePinyinAutoValue = isValidSignNamePinyin(generated) ? generated : '';
      this.$set(this.formData, 'signNamePinyin', this.signNamePinyinAutoValue);
    },
    /** 加载旧资料只补空值，英文名不会作为签单姓名来源。 */
    prepareSigningPinyin() {
      const saved = normalizeSignNamePinyin(this.formData.signNamePinyin);
      this.signNamePinyinAutoValue = '';
      if (!saved) this.generateSigningPinyin();
      else this.$set(this.formData, 'signNamePinyin', saved);
    },
    onSigningPinyinEdited() { this.signNamePinyinAutoValue = ''; },
    normalizeSigningPinyin() {
      this.$set(this.formData, 'signNamePinyin', normalizeSignNamePinyin(this.formData.signNamePinyin));
    }
  }
};
